import { TAG_CODES } from "../../tag.config"

const GOM_RESOURCE_GROUP = {
    type: 'path',
    tagCode: TAG_CODES.LAND_ASSET,
    withText: true,
    defaultText: 'Group',
    positionText: 'top', // top - right - center - bottom - left
    fieldsText: ["title"],
    endTextWidthStr: "",
    angle: 0,
    colorCodeId: 'fire',
    withFillColor: false,
    schema: {
        "type": 'object',
        "properties": {
            "title": {
                "title": "Text",
                "description": "Write a text",
                "type": "string",
            },
        },
        "required": []
    },
    pathData: `M 2.30 33.33 L 99.96 33.33 M 40.23 0 L 40.23 33.33 M 57.47 0 L 57.47 33.33 M 2.30 33.33 L 2.30 100 L 99.96 100 L 99.96 33.33`,
}

export default GOM_RESOURCE_GROUP